import { Component, Input } from '@angular/core';

export interface Certification {
  title: string;
  subtitle: string;
  img: string;
}

@Component({
  selector: 'fcp-section-certification',
  templateUrl: './section-certification.component.html',
  styleUrls: ['./section-certification.component.scss']
})
export class SectionCertificationComponent {

  @Input() public certification: Certification;

  constructor() { }



}
